import { render, staticRenderFns } from "./productReviewItems.vue?vue&type=template&id=b80410e4"
import script from "./productReviewItems.vue?vue&type=script&lang=js"
export * from "./productReviewItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports